import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetMessageTemplates = (params) => axios.get(apiPaths.messageTemplatesBase, { params });

const onGetPredefinedMessageTemplates = () => axios.get(apiPaths.messageTemplatesPredefinedBase);

const onCreateMessageTemplate = (payload) => axios.post(apiPaths.messageTemplatesBase, [payload]);
const onDeleteMessageTemplate = (id) => axios.post(`${apiPaths.messageTemplatesBase}/delete-many`, [id]);
const onUpdateMessageTemplate = (payload) => axios.put(apiPaths.messageTemplatesBase, [payload]);

export {
  onGetMessageTemplates,
  onGetPredefinedMessageTemplates,
  onCreateMessageTemplate,
  onDeleteMessageTemplate,
  onUpdateMessageTemplate
};
